import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

import { SUPPORTED_LOCALES } from "@/constants/locale";

function getLocale(locale) {
  switch (locale) {
    case "mx":
      return "es";
    default:
      return locale;
  }
}

let languages = SUPPORTED_LOCALES.map(value => {
  return value["code"];
});

let browserLang = navigator.language.split("-")[0];
const params = new URLSearchParams(window.location.search);
if (params.has("locale")) {
  console.log(params.get("locale"));
}
let lang = params.has("locale")
  ? getLocale(params.get("locale").toLocaleLowerCase())
  : languages.includes(browserLang)
  ? browserLang
  : "en";

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

export default new VueI18n({
  locale: lang,
  messages: loadLocaleMessages()
});
